import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const IconArrowLeft: FC<SVGAttributes<SVGElement>> = props => (
    <svg height="14" viewBox="0 0 20 14" width="20" {...props}>
        <path
            d="M.272 6.342L6.224.391a.93.93 0 011.315 1.315L3.175 6.07H19.07a.93.93 0 010 1.86H3.175l4.364 4.364a.93.93 0 11-1.315 1.315L.272 7.658a.93.93 0 010-1.316z"
            fill="currentColor"
        />
    </svg>
);
